import DropdownItem, { DropDownItemStyles } from 'Douleutaras/components/Dropdown/DropdownItem';
import React, { ReactNode } from 'react';

import './MenuChild.scss';

interface MenuChildProps {
  id: string;
  title: string;
  children: ReactNode;
  highlight?: boolean;
  icon?: React.JSX.Element;
  closeCallback(open: boolean): void;
}

export const MenuChild = ({ id, title, children, highlight, icon, closeCallback = (open: boolean) => true }: MenuChildProps) => {
  let menuStyle: DropDownItemStyles;

  switch (true) {
    case highlight:
      menuStyle = 'highlighted';
      break;
    default:
      menuStyle = 'divided-arrow';
      break;
  }

  return (
    <>
      <label htmlFor={id}>
        <DropdownItem
          icon={Boolean(icon) && <div styleName="dropdown-item-icon">{icon}</div>}
          text={title}
          style={menuStyle}
          isDiv
        />
      </label>

      <input type="checkbox" id={id} data-type="menu-child"/>
      <div styleName="dropdown-child">
        <div styleName="dropdown-child__header">
          <label styleName="dropdown-child__back" htmlFor={id}>
            <span className="dashicon dashicon-chevron-left"/>
          </label>
          <div styleName="dropdown-child__title">
            {title}
          </div>
          <div styleName="dropdown-child__close" onClick={() => closeCallback(false)}>
            <span className="dashicon dashicon-close"/>
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

export default MenuChild;
